import cloneDeep from 'lodash/cloneDeep';
import { api } from '@/api/api';
import { apis } from '@/config';
class TaskMailImplApi {
    constructor() {
        this.dbName = 'task_mail';
        this.taskTableName = 'task';
        this.taskListTableName = 'task_list';
        this.name = apis.taskMailImplApi;
        this.systemApi = api.getSystemApi();
        this.http = api.getDataTransApi();
        this.DBApi = api.getNewDBApi();
        this.eventApi = api.getEventApi();
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
        this.taskMailPageInfo = {
            pages: [0],
        };
    }
    init() {
        return this.name;
    }
    afterInit() {
        this.DBApi.initDb(this.dbName);
        return this.name;
    }
    async handlePromise(promise) {
        var _a;
        try {
            const res = await promise;
            const { data } = res;
            return data;
        }
        catch (e) {
            return {
                message: (_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.message,
                success: false,
            };
        }
    }
    saveTaskMailInDb(task) {
        return this.DBApi.put({
            tableName: this.taskTableName,
            dbName: this.dbName,
        }, task).then();
    }
    async assembleContact(tasks) {
        tasks = cloneDeep(tasks);
        const contactSet = new Set();
        const mapContact = new Map();
        tasks.forEach(task => {
            const taskId = task.todoId;
            const taskSet = new Set();
            if (task.createdBy) {
                contactSet.add(task.createdBy);
                taskSet.add(task.createdBy);
            }
            if (task.focusList && task.focusList.length > 0) {
                task.focusList.forEach(it => {
                    contactSet.add(it);
                    taskSet.add(it);
                });
            }
            if (task.executorList && task.executorList.length > 0) {
                task.executorList.forEach((_) => {
                    if (_.accId) {
                        contactSet.add(_.accId);
                        taskSet.add(_.accId);
                    }
                });
            }
            mapContact.set(taskId, taskSet);
        });
        const contactIds = Array.from(contactSet);
        const contactAllMap = new Map();
        if (contactIds.length > 0) {
            const infos = await this.contactApi.doGetContactById(contactIds);
            infos.forEach(item => {
                if (!contactAllMap.get(item.contact.id)) {
                    contactAllMap.set(item.contact.id, item);
                }
            });
        }
        tasks.forEach(task => {
            const taskId = task.todoId;
            const taskSet = mapContact.get(taskId);
            const taskContactList = new Map();
            if (taskSet) {
                taskSet.forEach(it => {
                    const value = contactAllMap.get(it);
                    if (value) {
                        taskContactList.set(it, value);
                    }
                });
            }
            task.contactList = taskContactList;
        });
        return tasks;
    }
    async taskMailModelFormat(task) {
        const contactSet = new Set();
        if (task.createdBy)
            contactSet.add(task.createdBy);
        if (task.focusList && task.focusList.length > 0)
            task.focusList.forEach(it => contactSet.add(it));
        if (task.executorList && task.executorList.length > 0) {
            task.executorList.forEach((_) => {
                if (_.accId)
                    contactSet.add(_.accId);
            });
        }
        const contactIds = Array.from(contactSet);
        const contactList = new Map();
        if (contactIds.length > 0) {
            const infos = await this.contactApi.doGetContactById(contactIds);
            infos.forEach(item => {
                if (!contactList.get(item.contact.id)) {
                    contactList.set(item.contact.id, item);
                }
            });
        }
        task.contactList = contactList;
        return task;
    }
    async taskMailDiffs(taskMailList) {
        const changeIds = [];
        const changeTaskMailMap = new Map();
        const todoIds = [];
        const taskMailListMap = new Map();
        const dbResultMap = new Map();
        taskMailList.forEach(task => {
            todoIds.push(task.todoId);
            taskMailListMap.set(task.todoId, task);
        });
        const dbResult = (await this.getTaskMailInDb(todoIds));
        dbResult.forEach(task => {
            dbResultMap.set(task.todoId, task);
        });
        todoIds.forEach(todoId => {
            const currentTaskMail = taskMailListMap.get(todoId);
            const currentDbTaskMail = dbResultMap.get(todoId);
            if (!currentDbTaskMail) {
                this.saveTaskMailInDb(currentTaskMail);
            }
            else {
                const isChange = this.diffHandler(currentTaskMail, currentDbTaskMail);
                if (isChange) {
                    changeIds.push(todoId);
                }
            }
        });
        changeIds.forEach(todoId => {
            this.saveTaskMailInDb(taskMailListMap.get(todoId));
            changeTaskMailMap.set(todoId, taskMailListMap.get(todoId));
        });
        if (changeIds.length > 0) {
            this.eventApi.sendSysEvent({
                eventName: 'todoChange',
                eventStrData: 'refreshTaskList',
                eventData: {
                    taskMailList: changeTaskMailMap,
                },
            });
            console.log('有变更，通知web更新');
        }
    }
    diffHandler(currentTaskMail, currentDbTaskMail) {
        const needDiff = ['alert', 'alertAt', 'alertTime', 'completed', 'deadline', 'groupType', 'overdue', 'status', 'type', 'userType'];
        for (let i = 0; i < needDiff.length; i++) {
            if (currentTaskMail[needDiff[i]] !== currentDbTaskMail[needDiff[i]]) {
                return true;
            }
        }
        const executorMap = new Map();
        const dbExecutorMap = new Map();
        const executorIds = [];
        const dbExecutorIds = [];
        currentTaskMail.executorList.forEach((_) => {
            executorIds.push(_.accId);
            executorMap.set(_.accId, _);
        });
        currentDbTaskMail.executorList.forEach((_) => {
            dbExecutorIds.push(_.accId);
            dbExecutorMap.set(_.accId, _);
        });
        if (executorIds.length !== dbExecutorIds.length) {
            return true;
        }
        for (let i = 0; i < executorIds.length; i++) {
            if (executorMap.get(executorIds[i]).completeTime !== dbExecutorMap.get(executorIds[i]).completeTime) {
                return true;
            }
            if (executorMap.get(executorIds[i]).status !== dbExecutorMap.get(executorIds[i]).status) {
                return true;
            }
        }
        return false;
    }
    async getTaskMailListInDb(params) {
        if (!params) {
            return Promise.reject(new Error('参数未传入'));
        }
        let todoToMails = [];
        let todoList = [];
        const todoToMailsIdDb = (await this.DBApi.getByEqCondition({
            dbName: this.dbName,
            tableName: this.taskListTableName,
        }));
        if (Array.isArray(todoToMailsIdDb) && todoToMailsIdDb.length > 0) {
            todoToMails = todoToMailsIdDb
                .filter(v => !!v)
                .map(v => ({
                todoId: v.todoId,
                tid: v.tid,
                mid: v.mid,
                top: v.top,
                pos: v.pos,
            }))
                .sort((a, b) => a.pos - b.pos);
        }
        if (todoToMails.length > 0) {
            const todoListIds = [...new Set(todoToMails.filter(v => v.top).map(v => v.todoId))].slice(0, 2);
            if (todoListIds.length > 0) {
                todoList = (await this.getTaskMailInDb(todoListIds));
            }
        }
        return {
            success: true,
            code: 200,
            data: {
                size: todoToMails.length,
                todoToMails,
                todoList,
                hasNextPage: 0,
            },
        };
    }
    async getTaskMailListInServer(params) {
        const isForInbox = params.detailCount === 2 && params.status === 1;
        const url = this.systemApi.getUrl('getTaskMailList');
        const res = await this.handlePromise(this.http.get(url, params, { noEnqueue: true }));
        if (res && res.data) {
            const { todoList, todoToMails } = res.data;
            if (todoList && todoList.length > 0) {
                res.data.todoList = await this.assembleContact(todoList);
                if (todoToMails && todoToMails.length > 0) {
                    if (isForInbox) {
                        const towTopMails = [];
                        const towTopSet = new Set();
                        res.data.todoList.some(outer => {
                            const { mailInfos } = outer;
                            if (Array.isArray(mailInfos) && mailInfos.length > 0) {
                                return mailInfos.some(inner => {
                                    const { mid } = inner;
                                    if (!towTopSet.has(mid)) {
                                        towTopSet.add(mid);
                                        towTopMails.push({
                                            todoId: outer.todoId,
                                            tid: inner.tid,
                                            mid: inner.mid,
                                            top: true,
                                            pos: towTopMails.length,
                                        });
                                    }
                                    return towTopSet.size > 1;
                                });
                            }
                            return false;
                        });
                        const newTodoMails = res.data.todoToMails
                            .filter(v => !towTopSet.has(v.mid))
                            .map((v, index) => (Object.assign(Object.assign({}, v), { top: false, pos: index + 100 })));
                        res.data.todoToMails = [...towTopMails, ...newTodoMails];
                    }
                    else {
                        let twoTopCount = 0;
                        let pos = 0;
                        res.data.todoToMails = todoList.reduce((total, outer) => {
                            const { mailInfos } = outer;
                            if (Array.isArray(mailInfos) && mailInfos.length > 0) {
                                const mails = mailInfos.map(inner => {
                                    const top = twoTopCount < 2;
                                    if (!top) {
                                        twoTopCount += 1;
                                    }
                                    pos += 1;
                                    return {
                                        todoId: outer.todoId,
                                        tid: inner.tid,
                                        mid: inner.mid,
                                        pos,
                                        top,
                                    };
                                });
                                total.push(...mails);
                            }
                            return total;
                        }, []);
                    }
                }
            }
        }
        return res;
    }
    async doGetFullTaskMailList(params, noCache, onlyDb) {
        console.log('[task-mail] noCache ', noCache, 'onlyDb ', onlyDb);
        if (onlyDb) {
            return this.getTaskMailListInDb(params);
        }
        if (params.status === 1 && params.detailCount === 2) {
            return this.doGetTaskMailList(params, noCache);
        }
        return this.getTaskMailListInServer(params);
    }
    async doGetTaskMailList(params, noCache) {
        var _a, _b;
        console.log('[task-mail] doGetTaskMailList start ', params, noCache);
        let cacheRes;
        if (!noCache) {
            cacheRes = await this.getTaskMailListInDb(params);
        }
        const netPromise = this.getTaskMailListInServer(params).then(async (netRes) => {
            console.log('[task-mail] doGetTaskMailList net ', cacheRes, netRes);
            this.syncTaskMail(netRes, cacheRes, { params, eventMerge: true, fromNetwork: noCache }).then();
            return netRes;
        });
        console.log('[task-mail] doGetTaskMailList end ', cacheRes, netPromise);
        return noCache || !((_a = cacheRes === null || cacheRes === void 0 ? void 0 : cacheRes.data) === null || _a === void 0 ? void 0 : _a.todoToMails) || ((_b = cacheRes === null || cacheRes === void 0 ? void 0 : cacheRes.data) === null || _b === void 0 ? void 0 : _b.todoToMails.length) === 0 ? netPromise : cacheRes;
    }
    async syncTaskMail(networkRes, cacheRes, conf) {
        const { params, eventMerge = true, fromNetwork = false } = conf;
        const dtA = (cacheRes || (await this.getTaskMailListInDb(params))).data;
        const dtB = networkRes.data;
        const isDiff = await this.syncTaskMailHandler(dtA, dtB);
        this.mailApi.doCallMailMsgCenter({
            type: 'syncMail',
            msgCenter: {
                merge: eventMerge,
                diff: !fromNetwork && isDiff,
                refreshType: 'task',
            },
        });
    }
    async syncTaskMailHandler(dtA, dtB) {
        if (!dtA && !dtB) {
            return false;
        }
        const todoListA = dtA && dtA.todoList ? dtA.todoList : [];
        const todoListB = dtB && dtB.todoList ? dtB.todoList : [];
        const toDoListDiff = await this.compareAndSyncTodoList(todoListA, todoListB);
        const todoMailsA = dtA && dtA.todoToMails ? dtA.todoToMails : [];
        const todoMailsB = dtB && dtB.todoToMails ? dtB.todoToMails : [];
        const toDoMailsDiff = await this.compareAndSyncTodoMail(todoMailsA, todoMailsB);
        console.log('[task-mail] syncTaskMailHandler toDoListDiff', toDoListDiff, 'toDoListDiff ', toDoMailsDiff);
        return toDoListDiff || toDoMailsDiff;
    }
    async compareAndSyncTodoList(dtA, dtB) {
        const changedModels = new Map();
        const dtAMap = dtA.reduce((total, current) => total.set(current.todoId, current), new Map());
        const dtBMap = dtB.reduce((total, current) => total.set(current.todoId, current), new Map());
        dtBMap.forEach((itemB, todoId) => {
            const itemA = dtAMap.get(todoId);
            if (!itemA || this.diffHandler(itemB, itemA)) {
                changedModels.set(todoId, itemB);
            }
        });
        const isDiff = changedModels.size > 0;
        if (isDiff) {
            const ids = [...changedModels.keys()];
            const db = {
                dbName: this.dbName,
                tableName: this.taskTableName,
            };
            const res = await this.DBApi.getByIds(db, ids);
            if (Array.isArray(res)) {
                const dbRes = res.filter(v => v);
                if (dbRes.length > 0) {
                    dbRes.forEach(v => {
                        const { todoId } = v;
                        const origin = changedModels.get(todoId) || {};
                        changedModels.set(todoId, Object.assign(Object.assign({}, v), origin));
                    });
                }
            }
            await this.DBApi.putAll(db, [...changedModels.values()]);
        }
        return isDiff;
    }
    getTaskPageInfo(idx) {
        let page = 1;
        if (idx === 0) {
            this.setTaskPageInfo(0, 0);
        }
        else {
            const { pages } = this.taskMailPageInfo;
            const maxPage = pages[pages.length - 1];
            if (idx > maxPage) {
                page = pages.length + 1;
            }
            else if (idx > 0) {
                for (let i = 0, len = pages.length; i < len; i++) {
                    if (idx <= pages[i]) {
                        page = i + 1;
                        break;
                    }
                }
            }
        }
        console.log('[task-mail] get page info', this.taskMailPageInfo.pages);
        return { page };
    }
    setTaskPageInfo(index, count) {
        if (index === 0) {
            this.taskMailPageInfo.pages = [0];
        }
        const { pages } = this.taskMailPageInfo;
        const lastCount = pages[pages.length - 1];
        if (index + count > lastCount) {
            this.taskMailPageInfo.pages.push(lastCount + count);
        }
        console.log('[task-mail] set page info', this.taskMailPageInfo.pages);
    }
    async compareAndSyncTodoMail(dtA, dtB) {
        let isDiff = dtB.length > 0 && dtA.length !== dtB.length;
        if (!isDiff) {
            let comparedCount = 0;
            for (let i = 0, len = dtA.length; i < len; i++) {
                const itemA = dtA[i];
                const itemB = dtB[i];
                if (!itemB) {
                    isDiff = true;
                    break;
                }
                const targets = ['todoId', 'mid', 'tid', 'top'];
                isDiff = targets.some(key => itemB[key] && itemA[key] !== itemB[key]);
                if (isDiff) {
                    break;
                }
                comparedCount += 1;
            }
            isDiff = isDiff || comparedCount < dtB.length;
        }
        if (isDiff) {
            const delIds = [...new Set(dtA.map(v => v.mid || 0))];
            const db = {
                dbName: this.dbName,
                tableName: this.taskListTableName,
            };
            await this.DBApi.deleteById(db, delIds);
            await this.DBApi.putAll(db, dtB);
        }
        return isDiff;
    }
    async getTaskMailInServer(todoIds) {
        const params = {
            todoIdList: typeof todoIds === 'number' ? todoIds.toString() : todoIds.join(','),
        };
        const url = this.systemApi.getUrl('getTaskMailContent');
        const res = await this.handlePromise(this.http.get(url, params));
        if (res && res.data && res.data.length > 0) {
            return this.assembleContact(res.data).then(taskMailList => {
                res.data = taskMailList;
                this.taskMailDiffs(taskMailList);
                return res;
            });
        }
        return res;
    }
    async doGetTaskMailContent(todoIds, noCache) {
        console.log('[task-mail] called ', todoIds, noCache);
        const todoIdsNum = Array.isArray(todoIds) ? todoIds.length : 1;
        const promise = this.getTaskMailInServer(todoIds);
        if (noCache) {
            return promise;
        }
        const dbResult = (await this.getTaskMailInDb(todoIds));
        console.log('[task-mail] called ', dbResult);
        if (dbResult && dbResult.length > 0 && dbResult.length >= todoIdsNum) {
            return {
                success: true,
                message: 'success',
                code: 200,
                data: dbResult,
            };
        }
        return promise;
    }
    async getTaskMailInDb(ids) {
        if (!ids) {
            return Promise.reject(new Error('参数未传入'));
        }
        const checkIds = Array.isArray(ids) ? ids : [ids];
        let result = (await this.DBApi.getByIds({
            tableName: this.taskTableName,
            dbName: this.dbName,
        }, checkIds));
        console.log('[task-mail] getTaskMailInDb ', result);
        result = result.filter(_ => _);
        if (result && result.length > 0) {
            return this.assembleContact(result).then(taskMailList => {
                result = taskMailList;
                return result;
            });
        }
        return result;
    }
    async doUrgeTask(params) {
        const url = this.systemApi.getUrl('urgeTask');
        const res = await this.handlePromise(this.http.post(url, params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }));
        return res;
    }
    async doOperateTask(params, userId) {
        const url = this.systemApi.getUrl('mailoperateTask');
        const res = await this.handlePromise(this.http.post(url, params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }));
        if (!res.success) {
            return res;
        }
        const dbData = (await this.getTaskMailInDb(params.todoId));
        if (!dbData || dbData.length === 0) {
            return res;
        }
        let executor = {};
        for (let i = 0; i < dbData[0].executorList.length; i++) {
            if (dbData[0].executorList[i].accId === userId) {
                executor = dbData[0].executorList[i];
            }
        }
        if (params.mark === 0 && executor.status === 1 && executor) {
            executor.status = 0;
            dbData[0].completed--;
            if (dbData[0].completed < dbData[0].total) {
                dbData[0].status = 0;
            }
        }
        else if (params.mark === 1 && executor.status === 0 && executor) {
            executor.status = 1;
            executor.completeTime = new Date().getTime();
            dbData[0].completed++;
            if (dbData[0].completed >= dbData[0].total) {
                dbData[0].status = 1;
            }
        }
        else if (params.mark === 2) {
            dbData[0].status = 2;
        }
        else if (params.mark === 3) {
            dbData[0].status = 0;
        }
        await this.saveTaskMailInDb(dbData[0]);
        return res;
    }
}
const taskMailImplApi = new TaskMailImplApi();
api.registerLogicalApi(taskMailImplApi);
export default taskMailImplApi;
